export const getHash = state => state.syncReducer.hashes.hash
export const getCreativesTimeStamp = state => state.syncReducer.hashes.creatives
export const getMotdLatestTimeStamp = state => state.syncReducer.hashes.motd
export const getNewsTimeStamp = state => state.syncReducer.hashes.news



// WEBPACK FOOTER //
// ./src/features/Sync/data/hashes/selectors.js